const MONTHS = { "01": "Ene", "02": "Feb", "03": "Mar", "04": "Abr", "05": "May", "06": "Jun", "07": "Jul",
                 "08": "Ago", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dic" };
const ACCENTS = { expomovil: "Expomóvil", movil: "Móvil", vehiculos: "Vehículos", credito: "Crédito", feria: "Feria",
                  navidena: "Navideña", exhibicion: "Exhibición", promocion: "Promoción", camion: "Camión",
                  temporada: "Temporada", dia: "Día", padres: "Padres", madres: "Madres", sabado: "Sábado" };
const KEEP_UPPER = new Set(["SDM", "PC", "STI", "JFK", "BHD", "APAP", "ND"]);

export function prettyCampaign(raw) {
  const m = String(raw || "").match(/^(\d{4})_([A-Za-z]{3}|\d{2})_(.+)$/);
  const [year, mon, rest] = m ? [m[1], m[2], m[3]] : ["", "", String(raw || "")];
  const words = rest.replace(/_/g, " ").replace(/([a-záéíóú])([A-Z])/g, "$1 $2").split(/\s+/).filter(Boolean)
    .map((w) => (KEEP_UPPER.has(w.toUpperCase()) ? w.toUpperCase() : ACCENTS[w.toLowerCase()] || w.charAt(0).toUpperCase() + w.slice(1)));
  const month = MONTHS[mon] || (mon ? mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase() : "");
  return { words, year, month };
}

function Title({ raw, small }) {
  const { words, year } = prettyCampaign(raw);
  return (
    <span title={raw} style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.04em", textTransform: "uppercase",
                               fontSize: small ? "0.7em" : undefined }}>
      {words.join(" ")}{year && <span style={{ color: "#f4c400" }}> {year}</span>}
    </span>
  );
}

export default function CampaignBanner({ campaign, compare, totals, updated }) {
  const list = String(campaign || "").split(",").filter((c) => c && c !== "Todas");
  if (!list.length) return null;
  const cmp = String(compare || "").split(",").filter((c) => c && c !== "Ninguna");
  const months = [...new Set(list.map((c) => { const p = prettyCampaign(c); return [p.month, p.year].filter(Boolean).join(" "); }).filter(Boolean))];
  const fmt = (v) => Number(v || 0).toLocaleString("es-DO");
  return (
    <section className="rounded-2xl px-5 sm:px-7 py-4 sm:py-5 mb-5 flex items-center justify-between gap-5 flex-wrap"
             style={{ background: "#111827", borderLeft: "8px solid #f4c400" }} data-testid="fni-campaign-banner">
      <div className="min-w-0">
        <div className="text-[10px] font-extrabold uppercase" style={{ letterSpacing: "0.3em", color: "#f4c400" }}>
          {list.length > 1 ? `${list.length} campañas activas` : "Campaña activa"}
        </div>
        <h2 className="text-[30px] sm:text-[42px] leading-none mt-1.5 text-white" data-testid="fni-campaign-banner-title">
          {list.map((c, i) => <span key={c}>{i > 0 && <span className="text-gray-500"> · </span>}<Title raw={c} small={list.length > 1}/></span>)}
        </h2>
        {cmp.length > 0 && (
          <div className="text-[20px] text-gray-400 mt-1" data-testid="fni-campaign-banner-compare">
            <span className="text-[12px] font-bold uppercase tracking-widest mr-1">vs</span>
            {cmp.map((c, i) => <span key={c}>{i > 0 && ", "}<Title raw={c}/></span>)}
          </div>
        )}
      </div>
      {totals && (
        <div className="text-right text-[12px] font-bold text-gray-400 leading-relaxed" data-testid="fni-campaign-banner-meta">
          {months.join(" · ")}<br/>{fmt(totals.leads)} leads · {fmt(totals.sometido)} sometidas
          {updated && <div className="text-[10px] font-semibold text-gray-500 mt-1" data-testid="fni-campaign-updated">Actualizado {updated} · archivo de oportunidades</div>}
        </div>
      )}
    </section>
  );
}
